import Label from "components/Label/Label";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import { avatarImgs } from "contains/fakeData";
import { AuthContext } from "context/AuthContext";
import { Resolver, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import CustomAlert from "components/CustomAlert";
import { updateAvatar, updateInfos, removeAvatarRequest } from "services/UserServices";
//import { MEDIA_URL } from "../../constants";
import env from "ts-react-dotenv";
import { useTranslation } from "react-i18next";

//const MEDIA_URL: string = (process.env.MEDIA_URL as string);
const MEDIA_URL: string = (env.MEDIA_URL as string);

export interface AccountPageProps {
  className?: string;
}

export type UserValues = {
  last_name: string;
  first_name: string;
  email: string;
  address: string;
  city: string;
  country: string;
  phone: string;
  about_me: string;
  gender: string;
};

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {

  const { t } = useTranslation();
  const { connected, user, afterLogin } = useContext(AuthContext);
  const { register, handleSubmit, reset, formState: { errors } } = useForm<UserValues>();
  const [image, setImage] = useState<Blob>();
  const [imageUrl, setImageUrl] = useState("");
  const [currentUser, setCurrentUser] = useState({
    id: 0,
    last_name: "",
    first_name: "",
    email: "",
    address: "",
    city: "",
    country: "",
    phone: "",
    gender: "",
    about_me: "",
  });

  useEffect(() => {

    if (user) {
      setImageUrl(MEDIA_URL + user.avatar);
      setCurrentUser((prevState) => ({
        ...prevState,
        id: user.id,
        last_name: user.last_name,
        first_name: user.first_name,
        email: user.email,
        address: user.address,
        city: user.city,
        country: user.country,
        phone: user.phone,
        gender: user.gender?user.gender:"Male",
        about_me: user.about_me,
      }));
    }

  }, [user]);

  const showAlert = (type: any, message: string) => {
    toast.custom(
      (t) => (
        <CustomAlert
          show={t.visible}
          type={type}
          message={message}
        />
      ),
      { position: "top-right", id: "nc-product-notify", duration: 3000 }
    );
  };

  const handleUploadImage = async (event: ChangeEvent) => {
    const { files } = event.target as HTMLInputElement;
    if (files && files.length !== 0) {
      setImage(files[0]);
      let url = URL.createObjectURL(files[0]);
      // console.log(files[0]);
      // console.log(url);
      setImageUrl(url);
      try {
        await updateAvatar(user?.id, files[0]);
        showAlert("success", "Avatar Updated Successfully !");
        afterLogin();
      } catch (error: any) {
        showAlert("error", error.message)
      }
    }
  }

  const removeAvatar = async () => {
    try {
        await removeAvatarRequest(user?.id, null);
        showAlert("success", "Avatar removed successfully !");
        afterLogin();
      } catch (error: any) {
        showAlert("error", error.message)
      }
}

  const handleChangeInput = (event: any) => {
    setCurrentUser((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  /*const saveAvatar =  async () => {
      try {
        await updateAvatar(user?.id, image);
        showAlert("success", "Avatar Updated Successfully !");
        afterLogin();
      } catch (error: any) {
        showAlert("error", error.message)
        console.log(error.message);
      }
  }*/

  const updateUser = async (data: any) => {   
    
    if (currentUser.email && currentUser.last_name && currentUser.country && currentUser.city && currentUser.address) {
    try {
      const result = await updateInfos(user?.id, currentUser, "");
      showAlert("success", "Information Updated Successfully !")
    } catch (error: any) {
      showAlert("error", error.message)
    }
  } else {
    showAlert("error", "Please fill all required fields!")
}
  };

  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Account || DoDo Shop</title>
      </Helmet>
      <CommonLayout>
        <div className="space-y-10 sm:space-y-12">
          {/* HEADING */}
          <h2 className="text-2xl sm:text-3xl font-semibold">
            {t("account_information")}
          </h2>
          <div className="flex flex-col md:flex-row">
            <div className="flex-shrink-0 flex items-start">
              {/* AVATAR */}
              <div className="relative rounded-full overflow-hidden flex">
                <img
                  src={imageUrl}
                  alt=""
                  className="w-32 h-32 rounded-full object-cover z-0"
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => { e.preventDefault(); handleUploadImage(e) }}
                  className="absolute inset-0 opacity-0 cursor-pointer"
                />
              </div>
              <div className="absolute ">
              {/* <ButtonPrimary type="button" //onClick={saveAvatar}
              >save avatar</ButtonPrimary> */}
                <i className="text-3xl cursor-pointer text-white ml-12 mb-6 las la-trash"
                onClick={removeAvatar}
                ></i>
            
              </div>
            </div>
            
            <div className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6">
              <form onSubmit={handleSubmit(updateUser)}>
                <div>
                  <Label>{t("first_name")}<span className="text-red-600">*</span></Label>
                  <Input className="mt-1.5" value={currentUser?.first_name} {...register("first_name")} onChange={handleChangeInput} />
                </div>

                <div>
                  <Label>{t("last_name")}<span className="text-red-600">*</span></Label>
                  <Input className="mt-1.5" value={currentUser?.last_name} {...register("last_name")} onChange={handleChangeInput} />
                </div>

                {/* ---- */}

                {/* ---- */}
                <div>
                  <Label>{t("email")}<span className="text-red-600">*</span></Label>
                  <div className="mt-1.5 flex">
                    <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                      <i className="text-2xl las la-envelope"></i>
                    </span>
                    <Input
                      className="!rounded-l-none"
                      type="email"
                      value={currentUser?.email}
                      disabled
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div>
                  <Label>{t("address")}<span className="text-red-600">*</span></Label>
                  <div className="mt-1.5 flex">
                    <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                      <i className="text-2xl las la-map-signs"></i>
                    </span>
                    <Input
                      className="!rounded-l-none"
                      value={currentUser?.address}
                      {...register("address")}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <Label>{t("city")}<span className="text-red-600">*</span></Label>
                    <Input className="mt-1.5" value={currentUser?.city} {...register("city")} onChange={handleChangeInput} />
                  </div>

                  <div>
                    <Label>{t("country")}<span className="text-red-600">*</span></Label>
                    <Input className="mt-1.5" value={currentUser?.country} {...register("country")} onChange={handleChangeInput} />
                  </div>
                </div>

                <div>
                  <Label>{t("gender")}</Label>
                  <Select className="mt-1.5"  {...register("gender")} name="gender" onChange={handleChangeInput}>
                    <option
                    selected={user.gender !== null && user.gender === "Male"}
                        value="Male">{t("male")}</option>
                    <option
                        selected={user.gender !== null && user.gender === "Female"}
                        value="Female">{t("female")}</option>
                  </Select>
                </div>

                {/* ---- */}
                <div>
                  <Label>{t("phone")}<span className="text-red-600">*</span></Label>
                  <div className="mt-1.5 flex">
                    <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                      <i className="text-2xl las la-phone-volume"></i>
                    </span>
                    <Input
                      className="!rounded-l-none"
                      value={currentUser?.phone}
                      {...register("phone")}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                {/* ---- */}
                <div>
                  <Label>{t("about_you")}</Label>
                  <Textarea className="mt-1.5" {...register("about_me")} onChange={handleChangeInput} value={currentUser?.about_me} /> 
                </div>
                <div className="pt-2">
                  <ButtonPrimary type="submit">{t("update_account")}</ButtonPrimary>
                </div>
              </form>
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPage;
